import api from './api';
import { PatternContainer } from '../types';

class PatternContainerService {
  async getAllContainers(): Promise<PatternContainer[]> {
    const response = await api.get('/pattern-containers/');
    // Handle both array and paginated response
    if (Array.isArray(response.data)) {
      return response.data;
    } else if (response.data.results) {
      return response.data.results;
    }
    return [];
  }

  async getContainer(id: number): Promise<PatternContainer> {
    const response = await api.get<PatternContainer>(`/pattern-containers/${id}/`);
    return response.data;
  }

  async createContainer(data: Partial<PatternContainer>): Promise<PatternContainer> {
    const response = await api.post<PatternContainer>('/pattern-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<PatternContainer>): Promise<PatternContainer> {
    const response = await api.put<PatternContainer>(`/pattern-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/pattern-containers/${id}/`);
  }
}

const patternContainerService = new PatternContainerService();
export default patternContainerService;
